function addTotal(cartTotal) {
  let newCartTotal = cartTotal.replace(/\$/g, "");
  newCartTotal = parseFloat(newCartTotal);
  // console.log(newCartTotal);
  let hasOrderedAlready = false;
  const currentOrder = JSON.parse(localStorage.getItem("realift:realfoot:order"));
  if(currentOrder) {
    const currentDate = new Date(currentOrder.date);
    const today = new Date();
      console.log(currentDate.getTime() / 1000, today.getTime() / 1000)
    
    if ((currentDate.valueOf() / 1000) - (today.valueOf() / 1000) < 10) {
      hasOrderedAlready = true;
      console.log("Order tracked already", currentDate.getTime() / 1000, today.getTime() / 1000)
    } else {
      console.log("Not ordered alredy", (currentDate.getTime() / 1000), (today.getTime() / 1000))
    }
  }
  if (localStorage.getItem("realift:hasMeasurements") && hasOrderedAlready == false && typeof window.gtag === "function") {
    console.log("Sending order to Google analytics")
    gtag("event", "realsize_add_total", {
      event_category: "RealSize",
      event_label: "RealSize Add Total",
      value: newCartTotal,
      send_to: "G-0D1CLYZ19Z",
    });
    gtag("event", "realsize_add_transaction", {
      event_category: "RealSize",
      event_label: "RealSize Add Transaction",
      value: 1,
      send_to: "G-0D1CLYZ19Z",
    });
    localStorage.setItem("realift:realfoot:order", JSON.stringify({ date: new Date().toUTCString() }));
  }
}

window.onload = function () {
  setTimeout(function () {
    // $(document).on("click", '[class="CustomCartRoot_button-checkout_3__Y2"],[data-testid="ShopifyPay-button"]', function () {
    //   jQuery.getJSON("/cart.js", function (cart) {
    //     console.log("Clicked");
    //     addTotal("$" + cart.total_price / 100);
    //   });
    // });

    // $(document).on('click', '[data-testid="ShopifyPay-button"]', function() {
    //   jQuery.getJSON("/cart.js", function (cart) {
    //     console.log("Clicked");
    //     addTotal("$" + cart.total_price / 100);
    //   });
    // });

    // const checkout = document.querySelector('[name="checkout"]');
    // if(checkout) {
    //   console.log("Checkout")
    //   checkout.addEventListener("click", function () {
    //     jQuery.getJSON("/cart.js", function (cart) {
    //       console.log("Clicked");
    //       addTotal("$" + cart.total_price / 100);
    //     });
    //   });
    // } else {
    //   console.log("Did not find checkout button")
    // }

    // Shopify

    // const shopifyPay = document.querySelector('[data-testid="ShopifyPay-button"]');
    // if (shopifyPay) {
    //   shopifyPay.addEventListener("click", function () {
    //     jQuery.getJSON("/cart.js", function (cart) {
    //       console.log("Clicked");
    //       addTotal("$" + cart.total_price / 100);
    //     });
    //   });
    // } else {
    //   console.log("Shopify element doesn't exist");
    // }
    
    // Google

    // const googlePay = document.querySelector('[data-testid="GooglePay-button"]');
    // googlePay.addEventListener("click", function () {
    //   jQuery.getJSON("/cart.js", function (cart) {
    //     addTotal("$" + cart.total_price / 100);
    //   });
    // });

    // Facebook/Meta

    // const facebookPay = document.querySelector('[data-testid="FacebookPay-button"]');
    // facebookPay.addEventListener("click", function () {
    //   jQuery.getJSON("/cart.js", function (cart) {
    //     addTotal("$" + cart.total_price / 100);
    //   });
    // });

    // Sezzle

    // const sezzlePay = document.querySelector(".sezzle-checkout-button");
    // sezzlePay.addEventListener("click", function () {
    //   jQuery.getJSON("/cart.js", function (cart) {
    //     addTotal("$" + cart.total_price / 100);
    //   });
    // });
  }, 1000);
  // PayPal

  // window.focus();

  // window.addEventListener("blur", () => {
  //   setTimeout(() => {
  //     if (document.activeElement.tagName === "IFRAME") {
  //       jQuery.getJSON("/cart.js", function (cart) {
  //         addTotal("$" + cart.total_price / 100);
  //       });
  //     }
  //   });
  // }, { once: false });
};
